export const tabOptions = [

    { label: 'Explore', icon: 'assets/images/search.png', route: '/chat-board' ,enabled:true},
    { label: 'Insights', icon: 'assets/images/knowledge.png', route: '/insights' ,enabled:true},
    { label: 'Word Cloud', icon: 'assets/images/cloud-search.png', route: '/word-cloud',enabled:true },
    { label: 'STEP', icon: 'assets/images/layout.png', route: '/dashboard1',enabled:true },
    { label: 'Dashboard 2', icon: 'assets/images/layout.png', route: '/dashboard2' ,enabled:true},
   
  ];

